<div class="card card-form-horizontal">
    <div class="card-content">

      <!--logo section -->
      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3 class="title hidden">able+</h3>
          </div>
        </div>
      </div>
      <!--logo section end-->

      <!--First step-->
      <div class="row" >
        <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
          <span *ngIf="showDeclinedText == true" class="input-group-addon">
            <p style="color: black;">The request to link the accounts has been cancelled.</p>
          </span>
          <span *ngIf="showLinkedText == true" class="input-group-addon">
            <p style="color: black;">The accounts have been linked.</p>
          </span>
        </div>
      </div>
      <!--first step end-->
      <div class="text-center margin-top-base padding-top-base">
        <span><a style="color: rgb(1, 85, 211); cursor: pointer;" (click)="navigateToLogin()">Log in</a></span>
      </div>
     
    </div>
  </div>